import { cn } from "@/utils/classnames"

export const Separator: React.FC<{ className?: string }> = ({ className }) => {
  return <div className={cn("m-0 h-[1px] w-full bg-bg-2", className)} />
}
